<!-- <div class="p-4 bg-white rounded-xl">
  Search + Filter + Add Contact
  <div class="flex gap-4 items-center mb-4">
    <mat-form-field  class="w-full">
      <mat-label>Search Scheme Name Here...</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search..." />
    </mat-form-field>

    <mat-form-field >
      <mat-label>Status</mat-label>
      <mat-select (selectionChange)="onChangeActive($event)">
        <mat-option value="">All</mat-option>
        <mat-option value="active">Active</mat-option>
        <mat-option value="inactive">Inactive</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" [routerLink]="'/home/create-contact'">
       Add Contact
    </button>
  </div> -->
  
  <div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input  class="w-full border p-2 rounded-md outline-none"
          placeholder="Search lead" matInput (keyup)="applyFilter($event)" />
      </div>
      <div class="w-80">
        <select style="background: #4d4de6;"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
          (change)="onChangeActive($event)">
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>

       
      </div>

      <div class="w-60">
        <app-primary-button [routerLink]="'/home/create-contact'" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add Contact</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>

  <!-- Angular Material Table -->
  <div class="bg-white rounded-2xl shadow-md p-4">

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 w-full">
    <!-- Columns -->

    <ng-container matColumnDef="sno">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> S.NO </th>
      <td mat-cell *matCellDef="let element; let i = index">
        {{ i + 1 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
    </ng-container>

    <ng-container matColumnDef="jobTitle">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Title </th>
      <td mat-cell *matCellDef="let element"> {{ element.jobTitle }} </td>
    </ng-container>

    <ng-container matColumnDef="accountName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Account </th>
      <td mat-cell *matCellDef="let element"> {{ element.accountName }} </td>
    </ng-container>

    <ng-container matColumnDef="officePhone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Office Number </th>
      <td mat-cell *matCellDef="let element"> {{ element.officePhone }} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
      <td mat-cell *matCellDef="let element"> {{ element.email }} </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> User </th>
      <td mat-cell *matCellDef="let element"> {{ element.user }} </td>
    </ng-container>

    <ng-container matColumnDef="dateCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Created </th>
      <td mat-cell *matCellDef="let element"> {{ element.dateCreated }} </td>
    </ng-container>

    <!-- Header and Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
<app-empty-data *ngIf="dataSource.data.length < 1" class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>
  <!-- Paginator -->
  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
  </div>
</div>
